<div class="{{ className }}">
  <label [attr.for]="effectiveInputId" [attr.id]="effectiveInputId + '-a11y-label'">{{ 'SELECT_ROOM' | translate }}</label>
  @if (form && controlName) {
    <app-auto-complete
      (selectedItemChange)="onSelectChangeRoom($event)"
      (searchChange)="onSearchChangeRoom($event)"
      [itemsData]="rooms"
      [selectedItem]="form.get(controlName)?.value"
      [minTermLength]="1"
      [disabled]="disabled"
      [inputId]="effectiveInputId"
      [labelElementId]="effectiveInputId + '-a11y-label'"
      [ariaLabel]="'SELECT_ROOM' | translate"
      [describedBy]="errorElementId ?? null"
      [ariaInvalid]="ariaInvalid"
    ></app-auto-complete>
  }
</div>
